// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__14xo2","empty":"ModalGraph_empty__2aKkd"};